import React from "react";
import Sitelogo from "./Logo";
import ClientHeaderNav from "./ClientHeaderNav";
import UserProfile from "./UserProfile";

const ClientHeader = () => {
  return (
    <div className="header-blocks">
      <header>
        <Sitelogo />
        <ClientHeaderNav />
        <UserProfile />
      </header>
      <div className="header-bottom-block">
        {/* <SearchBar
          setIsVisible={setIsVisible}
          setSelectedCustomer={setSelectedCustomer}
        /> */}
      </div>
    </div>
  );
};

export default ClientHeader;
